module.exports = __webpack_public_path__ + "401ef777e7aed62acf0c04190cefead4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/glyphs/j.png
// module id = 213
// module chunks = 0